import React from 'react'
import { RouteConstants } from '../../setup/routeConstants'

const LoginPageComponent = React.lazy(() => import('../../components/Login'))

export default {
	path: RouteConstants.login.path,
	element: <LoginPageComponent />,
}
